import React from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { FaLinkedin, FaEnvelope, FaPhone, FaMapMarkerAlt, FaYoutube } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  const navigate = useNavigate();

  const scrollToSection = (sectionId) => {
    if (location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate('/', { state: { scrollTo: sectionId } });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Brand Column */}
          <div className="footer-column footer-brand">
            <h3 className="footer-logo">UBOTIKA</h3>
            <p className="footer-tagline">AI Agents, Crafted for Results</p>
            <p className="footer-description">
              Boutique AI lab in Los Angeles designing intelligent agents built around outcomes.
              We empower local businesses to scale smarter, faster, and with purpose.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-column">
            <h4 className="footer-heading">Quick Links</h4>
            <nav className="footer-nav">
              <button onClick={() => scrollToSection('hero')} className="footer-link">Home</button>
              <button onClick={() => scrollToSection('about')} className="footer-link">About</button>
              <button onClick={() => scrollToSection('services')} className="footer-link">Services</button>
              <button onClick={() => scrollToSection('calculator')} className="footer-link">ROI Calculator</button>
              <button onClick={() => scrollToSection('faq')} className="footer-link">FAQ</button>
              <button onClick={() => scrollToSection('contact')} className="footer-link">Contact</button>
              <Link to="/about" className="footer-link">About</Link>
              <Link to="/ai-agents-los-angeles" className="footer-link">AI Agency LA</Link>
              <Link to="/blog" className="footer-link">Blog</Link>
              <Link to="/faq" className="footer-link">All FAQs</Link>
              <Link to="/compare" className="footer-link">Compare</Link>
              <Link to="/research" className="footer-link">Research</Link>
              <Link to="/partners" className="footer-link">Partners</Link>
            </nav>
          </div>

          {/* Services */}
          <div className="footer-column">
            <h4 className="footer-heading">Services</h4>
            <ul className="footer-list">
              <li><Link to="/web-apps">Custom Web Apps</Link></li>
              <li><Link to="/ai-agents-los-angeles">AI Agency in Los Angeles</Link></li>
              <li><Link to="/ai-phone-agents-los-angeles">AI Phone Agents</Link></li>
              <li><Link to="/ai-receptionist-los-angeles">AI Receptionist</Link></li>
              <li><Link to="/restaurant-ai-phone-agents-los-angeles">Restaurant AI Phone Agents</Link></li>
              <li><Link to="/dental-ai-receptionist-los-angeles">Dental AI Receptionist</Link></li>
              <li><Link to="/law-firm-ai-intake-los-angeles">Law Firm AI Intake</Link></li>
            </ul>
            <h4 className="footer-heading footer-heading-sub">Industries</h4>
            <ul className="footer-list">
              <li><Link to="/ai-receptionist-for-contractors">Contractors &amp; Home Services</Link></li>
              <li><Link to="/ai-receptionist-for-salons">Salons &amp; Spas</Link></li>
              <li><Link to="/ai-receptionist-for-restaurants">Restaurants</Link></li>
              <li><Link to="/ai-receptionist-for-medical-clinics">Medical Clinics</Link></li>
              <li><Link to="/ai-receptionist-for-property-management">Property Management</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-column">
            <h4 className="footer-heading">Contact</h4>
            <div className="footer-contact">
              <a
                href="https://maps.google.com/?cid=886761037595198009"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-item contact-link"
              >
                <FaMapMarkerAlt className="contact-icon" />
                <span>Los Angeles, CA</span>
              </a>
              <a href="tel:+13109123548" className="contact-item contact-link">
                <FaPhone className="contact-icon" />
                <span>(310) 912-3548</span>
              </a>
              <a href="mailto:hello@ubotika.com" className="contact-item contact-link">
                <FaEnvelope className="contact-icon" />
                <span>hello@ubotika.com</span>
              </a>
            </div>

            {/* Social Links */}
            <div className="footer-social">
              <h4 className="footer-heading">Follow Us</h4>
              <div className="social-links">
                <a
                  href="https://www.youtube.com/@Ubotika"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label="YouTube"
                >
                  <FaYoutube />
                </a>
                <a
                  href="https://www.linkedin.com/company/112106919/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label="LinkedIn"
                >
                  <FaLinkedin />
                </a>
                <a
                  href="https://x.com/ubotika"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label="X"
                >
                  <FaXTwitter />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="footer-copyright">
              &copy; {currentYear} UBOTIKA. All rights reserved.
            </p>
            <div className="footer-legal">
              <Link to="/privacy" className="legal-link">
                Privacy Policy
              </Link>
              <span className="legal-divider">|</span>
              <Link to="/terms" className="legal-link">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
